import { jsxs, jsx } from "react/jsx-runtime";
import Skeleton__default from "antd/es/skeleton";
import classnames from "../../utils/classnames.js";
import Collapse from "../Collapse/Collapse.js";
import Col from "../Grid/Col.js";
import "react";
import Row from "../Grid/Row.js";
import './Parameters.css';import '../Grid/Grid.css';/* empty css                */
import Icon from "../Icon/Icon.js";
import { compareParameterGroups } from "./Parameters.utils.js";
/* empty css                */
const Parameters = ({
  groups,
  children,
  activeGroups,
  onChange,
  header,
  footer,
  className,
  isLoading = false
}) => {
  const sortedGroups = [...groups].sort(compareParameterGroups);
  return /* @__PURE__ */ jsxs(Row, { className: classnames("perxis-auto-parameters", className), gutter: [0, "vertical-sky"], children: [
    /* @__PURE__ */ jsx(Col, { span: 24, className: classnames("perxis-auto-parameters__header"), children: header }),
    /* @__PURE__ */ jsx(Col, { span: 24, className: classnames("perxis-auto-parameters__body"), children: /* @__PURE__ */ jsx(
      Collapse,
      {
        expandIcon: ({ isActive }) => /* @__PURE__ */ jsx(Icon, { name: isActive ? "minus" : "plus", sticker: "parameters-expand-icon", size: 20 }),
        activeKey: activeGroups,
        onChange,
        items: sortedGroups.map((grid) => ({
          key: grid.id,
          label: /* @__PURE__ */ jsx(
            Skeleton__default,
            {
              active: true,
              title: false,
              loading: isLoading,
              paragraph: { rows: 1, width: "100%" },
              className: classnames("perxis-auto-parameters__skeleton"),
              children: grid.title
            }
          ),
          children: /* @__PURE__ */ jsx(
            Skeleton__default,
            {
              active: true,
              title: false,
              loading: isLoading,
              paragraph: { rows: grid.items.length * 2, width: "100%" },
              className: classnames("perxis-auto-parameters__skeleton"),
              children: children(grid)
            }
          )
        }))
      }
    ) }),
    /* @__PURE__ */ jsx(Col, { span: 24, className: classnames("perxis-auto-parameters__footer"), children: footer })
  ] });
};
export {
  Parameters as default
};
//# sourceMappingURL=Parameters.js.map
